import { type CustomFieldValueData } from '@/common/types/fields'

export type CompanyDetailsDTOV1 = {
  id: number
  name?: string
  address?: string
  zipCode?: string
  city?: string
  country?: string
  externalRef?: string
  phone1?: string
  phone2?: string
  email1?: string
  email2?: string
  // expand CUSTOM_FIELDS
  customFields?: CustomFieldValueData[]
}

export enum CompanyExpandEnum {
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
}

export const enum CompanyActionTypeEnum {
  COMPANY_CREATED = 'COMPANY_CREATED',
  COMPANY_ATTACHED_TO_CUSTOMER = 'COMPANY_ATTACHED_TO_CUSTOMER',
  COMPANY_ATTACHED_TO_CASE = 'COMPANY_ATTACHED_TO_CASE',
  COMPANY_UPDATED = 'COMPANY_UPDATED',
  COMPANY_UNLINK_CUSTOMER = 'COMPANY_UNLINK_CUSTOMER',
}

export interface CompanyActionFieldItem {
  label: string
  value?: string
  valueAfter?: string
}

export interface ListCompanyActionDTOV1 {
  date: string
  type: CompanyActionTypeEnum
  user?: string
  fields?: CompanyActionFieldItem[]
}

export type CompanyFieldConfig = {
  expands?: Set<CompanyExpandEnum>
}

export type Company = CompanyDetailsDTOV1 & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any
}
